module.exports = __webpack_public_path__ + "img/img_icon_142.097dae85.png";